<template>
  <div>
    <Header></Header>
    <Header1></Header1>
    <Center></Center>
  </div>
</template>
<script>
import Header from "./header.vue";
import Header1 from "./header1.vue";

import Center from "./center.vue";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Header1,
    Center,
  },
};
</script>
<style lang="scss" scoped>
</style>